/*
 *  I01EVAECSQUALII18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-09 23:21:37 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I01EVAECSQUALI_SECTION_0_TITLE: "Calculez votre production d'eau chaude sanitaire collective en fonction de la méthode Qualitel.",
  I01EVAECSQUALI_in_typeCalcul: '', //do not delete,required. auto generated code for empty title for segment
  I01EVAECSQUALI_in_typeCalcul_0: 'Stockage ECS',
  I01EVAECSQUALI_in_typeCalcul_1: 'Stockage primaire',
  I01EVAECSQUALI_in_t1_Ddo: 'T1 (douche)',
  I01EVAECSQUALI_in_t1_ba: 'T1 (baignoire)',
  I01EVAECSQUALI_in_t2_do: 'T2 (douche)',
  I01EVAECSQUALI_in_t2_ba: 'T2 (baignoire)',
  I01EVAECSQUALI_in_t3_ev_lav_ba: 'T3 ( un évier, un lavabo et une baignoire)',
  I01EVAECSQUALI_in_t3_ba_do: 'T3 (une baignoire et une douche)',
  I01EVAECSQUALI_in_t4_ba: 'T4 (une baignoire)',
  I01EVAECSQUALI_in_t4_ba_do: 'T4 (une baignoire et une douche)',
  I01EVAECSQUALI_in_t56_ba: 'T5 / T6 (une baignoire)',
  I01EVAECSQUALI_in_t56_ba_do: 'T5 / T6 (une baignoire et une douche)',
  I01EVAECSQUALI_in_T56_2ba: 'T5 / T6 (deux baignoires)',
  I01EVAECSQUALI_res_totalLogementStandard: 'Nombre de logements standards',
  I01EVAECSQUALI_SECTION_1_TITLE: 'Simultanéïté retenue',
  I01EVAECSQUALI_res_s1: 'Simultanéïté retenue S1',
  I01EVAECSQUALI_res_s2: 'Simultanéïté retenue S2',
  I01EVAECSQUALI_res_s3: 'Simultanéïté retenue S3',
  I01EVAECSQUALI_SECTION_2_TITLE: 'Echangeur instantané',
  I01EVAECSQUALI_in_tempFroide: 'Température Eau froide',
  I01EVAECSQUALI_in_tempBouclage: 'Température eau chaude',
  I01EVAECSQUALI_in_tempStackage: 'Température de stockage',
  I01EVAECSQUALI_in_tempRetour: 'Température Retour Echangeur',
  I01EVAECSQUALI_res_effEchangeur: 'Efficacité échangeur',
  I01EVAECSQUALI_res_debitDTU: 'Débit minimum DTU',
  I01EVAECSQUALI_res_puissMiniQualitel: 'Puissance mini Qualitel',
  I01EVAECSQUALI_SECTION_3_TITLE: 'Stockage',
  I01EVAECSQUALI_SECTION_3_TITLE2: "Stockage et puissance d'appoint",
  I01EVAECSQUALI_res_modePuissance: 'Mode',
  I01EVAECSQUALI_in_volume: 'Volume stockage',
  I01EVAECSQUALI_res_puissance: 'Puissance échangeur',
  I01EVAECSQUALI_in_volume2: 'Volume stockage',
  I01EVAECSQUALI_res_puissance2: 'Puissance générateur',
  I01EVAECSQUALI_res_simuDTU: 'Simultanéïté débit DTU',
  I01EVAECSQUALI_p_inst: 'Puissance Instantanée',
  I01EVAECSQUALI_couple_semi: 'Couple Semi-instantané',
  I01EVAECSQUALI_couple_semiacc: 'Couple Semi-accumulé',
  I01EVAECSQUALI_couple_acc: 'Couple à Accumulation',
  I01EVAECSQUALI_couple_acc_prim: 'Couple à accumulation',
  I01EVAECSQUALI_couple_semi_prim: 'Couple semi-instantané',
  I01EVAECSQUALI_couple_semiacc_prim: 'Couple semi-accumulé'
}
